class CutoutImage extends Konva.Image {
    constructor(config) {
      super(config);

      this.className = 'Cutout';
      
      this.config = {
        stroke: "#37393B",
        strokeWidth: 1, 
        fill: "transparent",
      };

      this.layer = config.layer;

      this.attrs.type = 'Cutout';
      this.attrs.draggable = true;
      this.attrs.resizable = true;
      this.attrs.sortable = true;

      this.loadSVG(config.svgString);

      console.log("CutoutImage Class", this);
    }

    loadSVG(svgString) {
        const blackStr = replaceAnyAttributeValue(replaceAnyAttributeValue(svgString, "fill", "#37393B"), "stroke", "#37393B");
        const base64Svg = removeXmlDeclaration(btoa(unescape(encodeURIComponent(blackStr))));
        const dataUrl = `data:image/svg+xml;base64,${base64Svg}`;

        Konva.Image.fromURL(dataUrl, (imageNode) => {
            console.log("CutoutImage Loaded", imageNode, imageNode.width(), imageNode.height());

            imageNode.x(this.config.x);
            imageNode.y(this.config.y);

            if (this.config.width) imageNode.width(this.config.width);
            if (this.config.height) imageNode.height(this.config.height);
            
            imageNode.draggable(true);

            /*
            let addingClickedObject = false;
            if (this.config.scaleX == undefined) {
                addingClickedObject = true;
            }
            */

            if (this.config.scale && this.config.scale != undefined) {
                this.config.scaleX = this.config.scale.x;
                this.config.scaleY = this.config.scale.y;
            }

            imageNode.setAttrs({
                isFlipped: false,
                type: this.config.type ?? "cutout",
                name: this.config.name ?? "cutout",
                group: this.config.group ?? "",
                numberLanes: 0,
                width: this.config.width ?? imageNode.width(),
                height: this.config.height ?? imageNode.height(),
                scaleX: 1,
                scaleY: 1,
                draggable: false,
                sortable: false,
            });

            imageNode.className = "Cutout";
            imageNode.setAttrs({
                globalCompositeOperation: 'destination-in'
            });

            this.layer.add(imageNode);
            imageNode.setZIndex(1);
            this.layer.batchDraw();
            //selectNode(imageNode);
            //resetTrackIndex();
            
            //console.log("addSvgImage", config, imageNode.getAttrs());

            /*  
            if (addingClickedObject === true) {
                if (this.config.group != "Tracks") {
                    while (imageNode.getClientRect().width < 200) {
                        imageNode.scale({ x: imageNode.scale().x * 1.5, y: imageNode.scale().y * 1.5 });
                    }
                }

                imageNode.offset({
                    x: imageNode.width() / 2,
                    y: imageNode.height() / 2,
                });
            }
            */

            /*
            if (this.config.rotation) {
                imageNode.setRotation(this.config.rotation);
            }
            */
        });
    }

}
